import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    if (!this.hasDialogTarget) return

    this._modal = Modal.getOrCreateInstance(this.dialogTarget)
    this._modal.show()

    // Clear the turbo frame after the modal finishes hiding so the next cell
    // click can open a fresh one
    this._onHidden = () => {
      const frame = this.element.closest("turbo-frame")
      if (frame) frame.innerHTML = ""
    }
    this.dialogTarget.addEventListener("hidden.bs.modal", this._onHidden)
  }

  disconnect() {
    if (!this.hasDialogTarget) return

    this.dialogTarget.removeEventListener("hidden.bs.modal", this._onHidden)
    this._modal?.hide()
    this._modal?.dispose()
  }
}
